import React from 'react';
import PropTypes from 'prop-types';
import ErrorPopup from '../ErrorPopup';

import './style.scss';

const BaseField = ({
  label,
  input,
  meta: {
    touched,
    error,
  },
}) => (
  <div className="field-base">
    <input className="field-base__input" {...input} placeholder={label} type="text" />
    {touched && error && <ErrorPopup text={error} />}
  </div>
);

BaseField.propTypes = {
  label: PropTypes.string,

  input: PropTypes.shape({
    value: PropTypes.any.isRequired,
    onChange: PropTypes.func.isRequired,
  }).isRequired,

  meta: PropTypes.shape({
    touched: PropTypes.any,
    error: PropTypes.any,
  }).isRequired,
};

BaseField.defaultProps = {
  label: '',
};

export default BaseField;



// WEBPACK FOOTER //
// ./src/components/ui/Fields/BaseField/index.js